import React, { useState, useEffect, useRef } from "react";
import styles from "./NewsItem.module.scss";
import DOMPurify from "dompurify";
import DefaultUserPicture from "resources/img/InBusiness/defaultUser.png";

import { Avatar } from "@mui/material";
import {
  EditButton,
  RemoveButton,
} from "lib/components/Buttons/buttons";
import ConfirmModal from "lib/components/Modals/ConfirmModal";
import { NewsAPI, UsersAPI } from "api_inbusiness";
import { getUserType } from "utils/functions";
import { useUser } from "hooks/useUser";
import { toast } from "react-toastify";

const NewsItem = ({ news, getNews, handleAddNewsEdit }) => {
  const { permissionsData } = useUser();
  const [profilePic, setProfilePic] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const iframeRef = useRef(null);

  useEffect(() => {
    (async () => {
      const { data: imgUrl } = await UsersAPI.getNewUserPicture(
        news.user.avatarId
      );
      setProfilePic(imgUrl);
    })();
  }, [news.user.avatarId]);

  const handleDeleteNews = async (id) => {
    try {
      const res = await NewsAPI.delete(id);
      if (res.ok) {
        getNews();
        toast.success("Ștergerea a fost efectuată cu succes!");
      }
    } catch (error) {
      toast.error("A intervenit o eroare!");
    }
  };

  // Auto-resize iframe based on content
  useEffect(() => {
    const resizeIframe = () => {
      if (iframeRef.current) {
        try {
          const height = iframeRef.current.contentWindow.document.body.scrollHeight;
          iframeRef.current.style.height = `${height + 20}px`;
        } catch (error) {
          // Ignore cross-origin errors
        }
      }
    };

    const timer = setTimeout(resizeIframe, 100);
    return () => clearTimeout(timer);
  }, [news.description]);

  return (
    <React.Fragment>
      <div className={styles.newsContainer}>
        <div className={styles.userSection}>
          <div className={styles.infoSection}>
            <div className={styles.avatarBox}>
              <Avatar
                src={profilePic ? profilePic : DefaultUserPicture}
                className={styles.avatar}
              />
            </div>
            <p className={styles.paragraphInfo}>
              {news.user?.firstName} {news.user?.lastName} -{" "}
              {getUserType(news.user?.type)}
            </p>
          </div>
          {permissionsData.seeAdminButtons && (
            <div className={styles.actionsSection}>
              <EditButton
                color="#1860D2"
                onClick={() => handleAddNewsEdit(news)}
              />
              <RemoveButton
                color="#1860D2"
                onClick={() => setOpenConfirm(true)}
              />
            </div>
          )}
        </div>
        <div className={styles.newsSection}>
          <h4 className={styles.title}>{news.title}</h4>
          <div className={styles.description}>
            <iframe
              ref={iframeRef}
              title={news.title}
              srcDoc={`
                <html>
                  <head>
                    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap" rel="stylesheet">
                    <style>
                      * { margin: 0; padding: 0; box-sizing: border-box; }
                      body {
                        font-family: 'Montserrat', sans-serif;
                        font-size: 15px;
                        line-height: 1.6;
                        color: #333;
                        padding: 1rem;
                      }
                      p { margin-bottom: 1rem; }
                      h1, h2, h3, h4, h5, h6 {
                        font-family: 'Montserrat', sans-serif;
                        margin-top: 1.5rem;
                        margin-bottom: 0.75rem;
                        font-weight: 600;
                      }
                      a { color: #4A90E2; text-decoration: none; }
                      a:hover { text-decoration: underline; }
                      img { max-width: 100%; height: auto; }
                      ul, ol { margin-left: 1.5rem; margin-bottom: 1rem; }
                      li { margin-bottom: 0.5rem; }
                    </style>
                  </head>
                  <body>
                    <base target="_blank" />
                    ${DOMPurify.sanitize(news.description)}
                  </body>
                </html>
              `}
            />
          </div>
        </div>
      </div>

      <ConfirmModal
        text={"Sunteți sigur că doriți să ștergeți această știre?"}
        buttonYes={"DA"}
        buttonNo={"NU"}
        onClickButtonYes={() => {
          handleDeleteNews(news.id);
          setOpenConfirm(false);
        }}
        open={openConfirm}
        setOpen={setOpenConfirm}
      />
    </React.Fragment>
  );
};

export default NewsItem;

